export default "__VITE_ASSET__C2rurcDY__"